/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    IconButton,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from "@mui/material";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import EditNoteIcon from "@mui/icons-material/EditNote";
import SearchBar from "../../../components/SearchBar";
import AddTaxRates from "../../../Modals/addtaxrates";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel({ children, value, index }: TabPanelProps) {
    return value === index ? <>{children}</> : null;
}

const VatInvoicing = () => {
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");

    const handleChangeTabs = (_: any, newValue: number) => {
        setValueTabs(newValue);
    };

    /* ================= INVOICE DATA ================= */
    const invoiceData = [
        {
            invoiceNo: "INV-1001",
            invoiceFrom: "Platform",
            invoiceTo: "TechHub Electronics",
            invoiceType: "Order",
            date: "01 Mar 2025",
            amount: "AED 1,050.00",
            status: "Paid",
            statusClass: "success",
        },
        {
            invoiceNo: "INV-1002",
            invoiceFrom: "Platform",
            invoiceTo: "Vendor ABC",
            invoiceType: "Subscription",
            date: "05 Mar 2025",
            amount: "AED 840.00",
            status: "Pending",
            statusClass: "warning",
        },
        {
            invoiceNo: "INV-1003",
            invoiceFrom: "Customer",
            invoiceTo: "Platform",
            invoiceType: "Platform Fees",
            date: "08 Mar 2025",
            amount: "AED 525.00",
            status: "Overdue",
            statusClass: "danger",
        },
    ];

    const taxRatesData = [
        {
            country: "United Arab Emirates",
            flag: "🇦🇪",
            region: "All Regions",
            taxType: "VAT",
            rate: "5%",
            effectiveFrom: "01 Jan 2018",
            status: "Active",
            statusClass: "success",
        },
        {
            country: "Saudi Arabia",
            flag: "🇸🇦",
            region: "All Regions",
            taxType: "VAT",
            rate: "15%",
            effectiveFrom: "01 Jul 2020",
            status: "Active",
            statusClass: "success",
        },
        {
            country: "United Kingdom",
            flag: "🇬🇧",
            region: "England",
            taxType: "VAT",
            rate: "20%",
            effectiveFrom: "01 Apr 2011",
            status: "Active",
            statusClass: "warning", // Yellowish in screenshot
        },
        {
            country: "India",
            flag: "🇮🇳",
            region: "GST",
            taxType: "GST",
            rate: "18%",
            effectiveFrom: "01 Jul 2017",
            status: "Inactive",
            statusClass: "default", // Grey in screenshot
        },
    ];
    const exemptionsData = [
        {
            entityId: "ENT-1001",
            entityType: "Vendor",
            exemptionType: "VAT Exempt",
            certificate: "VAT-EX-2024-001",
            validDate: "01 Jan 2024",
            status: "Active",
            statusClass: "success",
        },
        {
            entityId: "ENT-1002",
            entityType: "Customer",
            exemptionType: "Zero Rated",
            certificate: "ZR-2023-119",
            validDate: "15 Mar 2023",
            status: "Expired",
            statusClass: "warning", // Yellowish in screenshot
            rowClass: "warning_row",
        },
        {
            entityId: "ENT-1003",
            entityType: "Vendor",
            exemptionType: "Government Entity",
            certificate: "GOV-EX-7782",
            validDate: "01 Jun 2024",
            status: "Active",
            statusClass: "success",
        },
    ];
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            {/* ================= PAGE TITLE ================= */}
            <div className="main_title">
                <h1>VAT & Invoicing</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - VAT &
                    Invoicing
                </p>
            </div>

            {/* ================= STATS CARDS ================= */}
            <div className="stats_boxes gap_m">
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            12
                            <p>Total Invoices</p>
                        </h2>
                        <figure className="blue">
                            <DescriptionOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            8
                            <p>Paid Invoices</p>
                        </h2>
                        <figure className="success">
                            <PaidOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            3
                            <p>Pending Invoices</p>
                        </h2>
                        <figure className="warning">
                            <AccessTimeOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>
                            AED 115.00
                            <p>VAT Collected</p>
                        </h2>
                        <figure className="purple">
                            <PercentOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>

            {/* ================= TABS ================= */}
            <Box className="custom_tabs mt_20">
                <Tabs value={valueTabs} onChange={handleChangeTabs} className="custom_tabs_links">
                    <Tab label="Invoices" />
                    <Tab label="Tax Rates" />
                    <Tab label="Exemptions" />
                </Tabs>
            </Box>

            {/* ================= INVOICES TAB ================= */}
            <CustomTabPanel value={valueTabs} index={0}>
                <div className="table_flex mt_20">
                    <div className="lt">

                        <div className="cards ">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search invoices..."
                                        />
                                    </Box>
                                    {/* Filters */}
                                    <div className="form">
                                        <Select value="All Type" displayEmpty className="select_filter">
                                            <MenuItem value="All Type">All Type</MenuItem>
                                            <MenuItem value="Order">Order</MenuItem>
                                            <MenuItem value="Subscription">Subscription</MenuItem>
                                            <MenuItem value="Platform Fees">Platform Fees</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="form">
                                        <Select value="All Vendor" displayEmpty className="select_filter">
                                            <MenuItem value="All Vendor">All Vendor</MenuItem>
                                            <MenuItem value="Vendor ABC">Vendor ABC</MenuItem>
                                            <MenuItem value="TechHub Electronics">TechHub Electronics</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="form">
                                        <Select value="All Customer" displayEmpty className="select_filter">
                                            <MenuItem value="All Customer">All Customer</MenuItem>
                                            <MenuItem value="John Doe">John Doe</MenuItem>
                                            <MenuItem value="Jane Smith">Jane Smith</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="form">
                                        <Select value="All Status" displayEmpty className="select_filter">
                                            <MenuItem value="All Status">All Status</MenuItem>
                                            <MenuItem value="Paid">Paid</MenuItem>
                                            <MenuItem value="Pending">Pending</MenuItem>
                                            <MenuItem value="Overdue">Overdue</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="form">
                                        <input type="date" />
                                    </div>

                                    <div className="form">
                                        <Select value="AED" displayEmpty className="select_filter">
                                            <MenuItem value="AED">AED</MenuItem>
                                            <MenuItem value="USD">USD</MenuItem>
                                        </Select>
                                    </div>

                                </div>
                                <div className="right_s">
                                    <Button className="btn btn_warning" style={{ backgroundColor: "#D4AF37", color: "#fff", border: "none" }}>
                                        <img src="/static/images/export_icon.svg" /* Placeholder for export icon if needed, or use text */ alt="" style={{ marginRight: "5px", height: "16px", filter: "brightness(0) invert(1)" }} /> Export 
                                    </Button>
                                </div>
                            </div>
                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Invoice #</TableCell>
                                            <TableCell>From</TableCell>
                                            <TableCell>To</TableCell>
                                            <TableCell>Type</TableCell>
                                            <TableCell>Date</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {invoiceData.map((item, i) => (
                                            <TableRow key={i} hover>
                                                <TableCell>
                                                    <b>{item.invoiceNo}</b>
                                                </TableCell>

                                                <TableCell>{item.invoiceFrom}</TableCell>

                                                <TableCell>{item.invoiceTo}</TableCell>

                                                <TableCell>
                                                    <span className="badge badge_light">
                                                        {item.invoiceType}
                                                    </span>
                                                </TableCell>

                                                <TableCell>{item.date}</TableCell>

                                                <TableCell>
                                                    <b>{item.amount}</b>
                                                </TableCell>

                                                <TableCell>
                                                    <span className={`badge1 ${item.statusClass}`}>
                                                        {item.status}
                                                    </span>
                                                </TableCell>

                                                <TableCell>
                                                    <div className="action_btns">

                                                        <IconButton onClick={() => navigate("view")}>
                                                            <VisibilityOutlinedIcon fontSize="small" />
                                                        </IconButton>

                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="table_footer" style={{ background: "#FDFBF7", padding: "12px 20px", borderTop: "1px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <div style={{ background: "#D4AF37", borderRadius: "6px", width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
                                        <MonetizationOnOutlinedIcon fontSize="small" />
                                    </div>
                                    <span style={{ fontSize: "13px", color: "#333", fontWeight: 600 }}>Avg VAT Rate: 13.3% <span style={{ fontWeight: 400, color: "#666" }}>based on active rates</span></span>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>

            {/* ================= TAX RATES TAB ================= */}
            <CustomTabPanel value={valueTabs} index={1}>
                <div className="table_flex">
                    <div className="lt">

                        <div className="cards mt_20">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search tax rates..."
                                        />
                                    </Box>

                                    {/* Filters */}
                                    <div className="form">
                                        <Select value="All Type" displayEmpty className="select_filter">
                                            <MenuItem value="All Type">All Type</MenuItem>
                                            <MenuItem value="VAT">VAT</MenuItem>
                                            <MenuItem value="GST">GST</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="form">
                                        <Select value="All Regions" displayEmpty className="select_filter">
                                            <MenuItem value="All Regions">All Regions</MenuItem>
                                            <MenuItem value="Asia">Asia</MenuItem>
                                            <MenuItem value="Europe">Europe</MenuItem>
                                        </Select>
                                    </div>

                                    <div className="form">
                                        <Select value="All Status" displayEmpty className="select_filter">
                                            <MenuItem value="All Status">All Status</MenuItem>
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="Inactive">Inactive</MenuItem>
                                        </Select>
                                    </div>

                                    <div className="form">
                                        <input type="date" />
                                    </div>

                                    <div className="form">
                                        <Select value="AED" displayEmpty className="select_filter">
                                            <MenuItem value="AED">AED</MenuItem>
                                            <MenuItem value="USD">USD</MenuItem>
                                        </Select>
                                    </div>
                                </div>
                                <div className="right_s">
                                    <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
                                        Add Tax Rate
                                    </Button>
                                    <Button className="btn btn_warning" style={{ backgroundColor: "#D4AF37", color: "#fff", border: "none" }}>
                                        <img src="/static/images/export_icon.svg" /* Placeholder */ alt="" style={{ marginRight: "5px", height: "16px", filter: "brightness(0) invert(1)" }} /> Export 
                                    </Button>
                                </div>
                            </div>
                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Country</TableCell>
                                            <TableCell>Region</TableCell>
                                            <TableCell>Tax Type</TableCell>
                                            <TableCell>Rate</TableCell>
                                            <TableCell>Effective From</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {taxRatesData.map((item, index) => (
                                            <TableRow key={index} hover>
                                                {/* Country */}
                                                <TableCell>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <span style={{ fontSize: "20px" }}>{item.flag}</span>
                                                        <b>{item.country}</b>
                                                    </div>
                                                </TableCell>

                                                {/* Region */}
                                                <TableCell>{item.region}</TableCell>

                                                {/* Tax Type */}
                                                <TableCell>{item.taxType}</TableCell>

                                                {/* Rate */}
                                                <TableCell>
                                                    <b>{item.rate}</b>
                                                </TableCell>

                                                {/* Effective From */}
                                                <TableCell>{item.effectiveFrom}</TableCell>

                                                {/* Status */}
                                                <TableCell>
                                                    <span className={`badge1 ${item.statusClass}`}>
                                                        {item.status}
                                                    </span>
                                                </TableCell>

                                                <TableCell>
                                                    <div className="action_btns">

                                                        <IconButton onClick={() => setOpenModal(true)}>
                                                            <EditNoteIcon fontSize="small" />
                                                        </IconButton>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* Footer */}
                            <div className="table_footer" style={{ background: "#FDFBF7", padding: "12px 20px", borderTop: "1px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <div style={{ background: "#D4AF37", borderRadius: "6px", width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
                                        <MonetizationOnOutlinedIcon fontSize="small" />
                                    </div>
                                    <span style={{ fontSize: "13px", color: "#333", fontWeight: 600 }}>Avg VAT Rate: 13.3% <span style={{ fontWeight: 400, color: "#666" }}>based on active rates</span></span>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>

            {/* ================= EXEMPTIONS TAB ================= */}
            {/* ================= EXEMPTIONS TAB ================= */}
            <CustomTabPanel value={valueTabs} index={2}>
                <div className="table_flex">
                    <div className="lt">

                        <div className="cards">
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search exemptions..."
                                        />
                                    </Box>

                                    {/* Filters */}
                                    <div className="form">
                                        <Select value="All Types" displayEmpty className="select_filter">
                                            <MenuItem value="All Types">All Types</MenuItem>
                                            <MenuItem value="VAT Exempt">VAT Exempt</MenuItem>
                                            <MenuItem value="Zero Rated">Zero Rated</MenuItem>
                                            <MenuItem value="Government Entity">Government Entity</MenuItem>
                                        </Select>
                                    </div>

                                    <div className="form">
                                        <Select value="All Vendor" displayEmpty className="select_filter">
                                            <MenuItem value="All Vendor">All Vendor</MenuItem>
                                            <MenuItem value="Vendor ABC">Vendor ABC</MenuItem>
                                        </Select>
                                    </div>


                                    <div className="form">
                                        <input type="date" />
                                    </div>

                                    <div className="form">
                                        <Select value="AED" displayEmpty className="select_filter">
                                            <MenuItem value="AED">AED</MenuItem>
                                            <MenuItem value="USD">USD</MenuItem>
                                        </Select>
                                    </div>
                                </div>
                                <div className="right_s">
                                    <Button className="btn btn_warning" style={{ backgroundColor: "#D4AF37", color: "#fff", border: "none" }}>
                                        <img src="/static/images/export_icon.svg" /* Placeholder */ alt="" style={{ marginRight: "5px", height: "16px", filter: "brightness(0) invert(1)" }} /> Export 
                                    </Button>
                                </div>
                            </div>
                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Entity ID</TableCell>
                                            <TableCell>Entity Type</TableCell>
                                            <TableCell>Exemption Type</TableCell>
                                            <TableCell>Certificate</TableCell>
                                            <TableCell>Valid Period</TableCell>
                                            <TableCell>Status</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {exemptionsData.map((item, index) => (
                                            <TableRow key={index} hover style={item.rowClass ? { backgroundColor: "#FFF8E1" } : {}}>
                                                {/* Entity ID */}
                                                <TableCell>
                                                    <b>{item.entityId}</b>
                                                </TableCell>

                                                {/* Entity Type */}
                                                <TableCell>{item.entityType}</TableCell>

                                                {/* Exemption Type */}
                                                <TableCell>{item.exemptionType}</TableCell>

                                                {/* Certificate */}
                                                <TableCell>{item.certificate}</TableCell>

                                                {/* Valid Period (Start Date) */}
                                                <TableCell>{item.validDate}</TableCell>

                                                {/* Status */}
                                                <TableCell>
                                                    <span className={`badge1 ${item.statusClass}`}>
                                                        {item.status}
                                                    </span>
                                                </TableCell>


                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* Footer */}
                            <div className="table_footer" style={{ background: "#FDFBF7", padding: "12px 20px", borderTop: "1px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <div style={{ background: "#FFCC80", borderRadius: "6px", width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", color: "#E65100" }}>
                                        <WarningAmberOutlinedIcon fontSize="small" />
                                    </div>
                                    <span style={{ fontSize: "13px", color: "#333", fontWeight: 600 }}>1 expired exemption requires update</span>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                    <div className="rt">
                        <div className="ai_panel">
                            <h4>AI Insights</h4>

                            <div className="ai_alert warning">
                                <span className="icon">⚠️</span>
                                <p>
                                    <b>7 SKUs</b> need immediate attention
                                </p>
                            </div>

                            <div className="ai_alert danger">
                                <span className="icon">⛔</span>
                                <p>
                                    <b>3 SKUs</b> have zero sales in 30 days
                                </p>
                            </div>

                            <small className="ai_update">
                                Next updated ETA: <b>May 5, 2024</b>
                            </small>

                            <div className="ai_sku_list">
                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_002</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>

                                <div className="ai_sku_row">
                                    <div className="ai_sku_info">
                                        <h5>#PRD_010</h5>
                                        <p>Likely to go out of stock by May</p>
                                    </div>
                                    <button className="ai_action_btn">Actions ▾</button>
                                </div>
                            </div>

                            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                        </div>
                    </div>
                </div>
            </CustomTabPanel>
            <AddTaxRates
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default VatInvoicing;
